module.exports = __webpack_public_path__ + "static/pic06-51987215d3755da7939283c1633999de.jpg";